/* app/js/src/components/calendar/subtitles-popover.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  width: 335px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  border-radius: 4px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  border: solid 1px #e1e6eb;
}
header {
  font-size: 12px;
  letter-spacing: 0.1px;
  padding: 13px 13px 9px 13px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  color: #232f3a;
  position: relative;
}
header i {
  margin-right: 8px;
}
header i ::ng-deep svg path {
  fill: #232f3a;
}
header .title {
  margin-right: 5px;
}
header .capsule-count {
  font-size: 9px;
  line-height: 1;
  text-align: center;
  border-radius: 7.5px;
  margin: 2px;
  padding: 3px 5px;
  background-color: #16abe4;
  text-transform: uppercase;
}
header .close-btn {
  position: absolute;
  right: 9.1px;
  top: 13px;
  color: #879baf;
  cursor: pointer;
}
.subtitle {
  padding: 13px 50px 10px 13px;
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  background-color: #f5f9fd;
  text-transform: uppercase;
}
/*# sourceMappingURL=subtitles-popover.component.css.map */
